/* OYL Desktop Nav — v1 (April 2026)
 * Handles the sticky-condense behavior: after 120px scroll, the utility strip
 * slides up and the main nav tightens. Mobile viewport: elements are hidden
 * via CSS, binding is still harmless.
 */

(function(){
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    var utility = document.getElementById('oyl-nav-utility');
    var nav     = document.getElementById('oyl-nav-main');
    if (!utility || !nav) return;

    var ticking = false;
    function update() {
      var y = window.scrollY || window.pageYOffset;
      if (y > 120) {
        utility.classList.add('hidden');
        nav.classList.add('condensed');
      } else {
        utility.classList.remove('hidden');
        nav.classList.remove('condensed');
      }
      ticking = false;
    }

    window.addEventListener('scroll', function(){
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }
})();